module.exports = __webpack_public_path__ + "img/photo-0094.e6856033.jpg";